import { isDefined } from '@sgme/fp';
import { useLiveSummary } from 'components/common-form/sidePanel/docToolbar/summary/hooks/useLiveSummary';
import {
  SecondarySummaryBlock,
  SummaryFieldRowSecondary,
} from 'components/common-form/sidePanel/docToolbar/summary/ShareButtonSecondary';
import { FC } from 'react';

interface LiveSecondarySummaryModalProps {
  tabId: string;
}

export const LiveSecondarySummaryModal: FC<LiveSecondarySummaryModalProps> = ({ tabId }) => {
  const liveSummaryMailRequestProps = useLiveSummary(tabId);

  return (
    <>
      <SecondarySummaryBlock title="Quote id">
        <SummaryFieldRowSecondary labelKey="sidePanel.doc.summary.secondary.row.quote">
          {liveSummaryMailRequestProps.quoteId}
        </SummaryFieldRowSecondary>
        {isDefined(liveSummaryMailRequestProps.traceReporting) ? (
          <SummaryFieldRowSecondary labelKey="traceReporting">
            {liveSummaryMailRequestProps.traceReporting}
          </SummaryFieldRowSecondary>
        ) : null}
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Client">
        <SummaryFieldRowSecondary labelKey="client">{liveSummaryMailRequestProps.client}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="custodian">
          {liveSummaryMailRequestProps.custodian}
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Product">
        <SummaryFieldRowSecondary labelKey="isin">{liveSummaryMailRequestProps.isinCode}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="fileCode">{liveSummaryMailRequestProps.fileCode}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="ric">{liveSummaryMailRequestProps.ric}</SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Trade information">
        <SummaryFieldRowSecondary labelKey="settlementPrice">
          {liveSummaryMailRequestProps.settlementPrice}
        </SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="quantity">{liveSummaryMailRequestProps.quantity}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="settlementCashAmount">
          {liveSummaryMailRequestProps.settlementCashAmount}
        </SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="tradeWay">{liveSummaryMailRequestProps.tradeWay}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="upfront">{liveSummaryMailRequestProps.upfront}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="settlementUnit">
          {liveSummaryMailRequestProps.liveSettlementUnit}
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Dates">
        <SummaryFieldRowSecondary labelKey="tradeDate">
          {liveSummaryMailRequestProps.tradeDate}
        </SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="settlementDate">
          {liveSummaryMailRequestProps.settlementDate}
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
    </>
  );
};

LiveSecondarySummaryModal.displayName = 'LiveSecondarySummaryModal';
